<template>
  <div class="actions">
    <Action
      v-if="content.video"
      @click="$emit('toggleVideo')"
      ofType="trigger"
      content=""
      :isLoading="isLoading"
      :disabled="!hasAccess('video')"
      :class="[
        isContentSelected('video'),
        !hasAccess('video') && 'action__trigger--disabled',
      ]"
      v-tooltip="{
        content: 'Open Video',
        placement: 'bottom-center',
      }"
    >
      <template v-slot:icon>
        <VideoIcon
          :fill="hasCompleted('video')"
          class="action__trigger--icon"
        />
      </template>
    </Action>
    <Action
      v-if="content.quiz"
      ofType="trigger"
      @click="$emit('toggleQuiz')"
      :class="[
        isContentSelected('quiz'),
        !hasAccess('quiz') && 'action__trigger--disabled',
      ]"
      content=""
      :isLoading="isLoading"
      :disabled="!hasAccess('quiz')"
      v-tooltip="{
        content: 'Open Quiz',
        placement: 'bottom-center',
      }"
    >
      <template v-slot:icon>
        <QuizIcon :fill="hasCompleted('quiz')" class="action__trigger--icon" />
      </template>
    </Action>
    <Action
      v-if="content.exercises"
      ofType="trigger"
      @click="$emit('toggleExercise')"
      :class="[
        isContentSelected('exercises'),
        !hasAccess('exercises') && 'action__trigger--disabled',
      ]"
      content=""
      :isLoading="isLoading"
      :disabled="!hasAccess('exercises')"
      v-tooltip="{
        content: 'Open Exercises',
        placement: 'bottom-center',
      }"
    >
      <template v-slot:icon>
        <ExerciseIcon
          stroke-width="3"
          :stroke="hasCompleted('exercises')"
          class="action__trigger--icon actions__exercise-icon"
        />
        <div class="action__trigger--pill" v-if="content.exercises.length > 1">
          {{ content.exercises.length }}
        </div>
      </template>
    </Action>
  </div>
</template>

<script>
import { isFreeContent } from '@/helpers'
import QuizIcon from '@/assets/icons/course/quiz_icon.svg'
import VideoIcon from '@/assets/icons/course/video_icon.svg'
import ExerciseIcon from '@/assets/icons/course/exercise/exercise-icon.svg'
import Action from '@/components/shared/Action.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'Actions',
  components: {
    ExerciseIcon: { ...ExerciseIcon, name: 'ExerciseIcon' },
    QuizIcon: { ...QuizIcon, name: 'QuizIcon' },
    VideoIcon: { ...VideoIcon, name: 'VideoIcon' },
    Action,
  },
  props: {
    isUser: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    isContentEngaged: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    hasAccess(type) {
      if (this.content[type]) {
        if (this.isUser) return true
        if (type === 'exercises' && this.content[type].length) {
          return this.content[type].some(e => isFreeContent(e))
        }
        return isFreeContent(this.content[type])
      }
      return false
    },
    hasCompleted(type) {
      if (!this.hasAccess(type)) return '#3A3A3A'
      const completed = '#00DEA0'
      const unstarted = '#808080'
      if (this.content[type]) {
        if (type === 'exercises') {
          return this.content[type].every(
            e => e.user_status === CONSTANTS.CONTENT_USER_STATUS.FINISHED
          )
            ? completed
            : unstarted
        }
        return this.content[type].user_status ===
          CONSTANTS.CONTENT_USER_STATUS.FINISHED
          ? completed
          : unstarted
      }
    },
    isContentSelected(type) {
      const engaged = 'action__trigger--selected'
      const disengaged = 'action__trigger'
      return this.isContentEngaged[type] ? engaged : disengaged
    },
  },
}
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 3px;
  &__exercise-icon {
    height: 100%;
    width: 100%;
  }
}
</style>
